// 对监测点详情进行简化
// 获取挂载详情简要信息 用于拼接到url
export const getCarrierInfoBrief = function (carrierInfo = {}) {
  const {
    id,
    keycode,
    scene_id,
    typeId,
    description,
    fullPath,
    structureId
  } = carrierInfo
  return {
    carrierId: id,
    carrierName: keycode,
    sceneId: scene_id,
    carrierType: typeId,
    description,
    structureId,
    fullPath
  }
}

// 恢复CarrierInfo原来的字段名
export const restoreCarrierInfoBrief = function (carrierInfo) {
  const { carrierId, carrierName, sceneId, carrierType } = carrierInfo
  carrierInfo = {
    ...carrierInfo,
    id: carrierId,
    keycode: carrierName,
    scene_id: sceneId,
    typeId: carrierType
  }
  return carrierInfo
}
